
    import { Vue, Component, Prop } from "vue-property-decorator";
    import getDefaultImageName from "@/helpers/getDefaultImageName";
    import imgA from "@/components/icons/staffCardPlaceholders/imgA.vue";
    import imgB from "@/components/icons/staffCardPlaceholders/imgB.vue";
    import imgC from "@/components/icons/staffCardPlaceholders/imgC.vue";
    import imgD from "@/components/icons/staffCardPlaceholders/imgD.vue";
    import imgE from "@/components/icons/staffCardPlaceholders/imgE.vue";
    import imgF from "@/components/icons/staffCardPlaceholders/imgF.vue";
    import imgG from "@/components/icons/staffCardPlaceholders/imgG.vue";
    import imgH from "@/components/icons/staffCardPlaceholders/imgH.vue";
    import imgI from "@/components/icons/staffCardPlaceholders/imgI.vue";
    import imgJ from "@/components/icons/staffCardPlaceholders/imgJ.vue";
    import imgK from "@/components/icons/staffCardPlaceholders/imgK.vue";
    import imgL from "@/components/icons/staffCardPlaceholders/imgL.vue";
    import imgM from "@/components/icons/staffCardPlaceholders/imgM.vue";
    import imgN from "@/components/icons/staffCardPlaceholders/imgN.vue";
    import imgO from "@/components/icons/staffCardPlaceholders/imgO.vue";
    import imgP from "@/components/icons/staffCardPlaceholders/imgP.vue";
    import imgQ from "@/components/icons/staffCardPlaceholders/imgQ.vue";
    import imgR from "@/components/icons/staffCardPlaceholders/imgR.vue";
    import imgS from "@/components/icons/staffCardPlaceholders/imgS.vue";
    import imgT from "@/components/icons/staffCardPlaceholders/imgT.vue";
    import imgU from "@/components/icons/staffCardPlaceholders/imgU.vue";
    import imgV from "@/components/icons/staffCardPlaceholders/imgV.vue";
    import imgW from "@/components/icons/staffCardPlaceholders/imgW.vue";
    import imgX from "@/components/icons/staffCardPlaceholders/imgX.vue";
    import imgY from "@/components/icons/staffCardPlaceholders/imgY.vue";
    import imgZ from "@/components/icons/staffCardPlaceholders/imgZ.vue";
  
    @Component({
      components: {
        imgA,
        imgB,
        imgC,
        imgD,
        imgE,
        imgF,
        imgG,
        imgH,
        imgI,
        imgJ,
        imgK,
        imgL,
        imgM,
        imgN,
        imgO,
        imgP,
        imgQ,
        imgR,
        imgS,
        imgT,
        imgU,
        imgV,
        imgW,
        imgX,
        imgY,
        imgZ,
      },
    })
    export default class DefaultProjectImageNewDashBoard extends Vue {
      @Prop({ type: String, required: true }) readonly title!: string;
  
      get defaultImageComponentName(): string {
        return getDefaultImageName(this.title);
      }
    }
  